<template>
  <div>

      <h5>アクティビティ</h5>
      <hr>
      <div class="py-3 contents">

        <div class="col-md-12 sp-form-container">
            <div class="">
                <div class="">

                    <div class="card col-md-12 pl-0 pr-0 m-0 mb-2">
                        <div class="card-header" style="background: linear-gradient(to bottom, #f9f9f9 0%, #ececec 100%);">
                            <div class="row">
                                <span class="col-md-12 text-left"><h5 class="mb-0">販売者からの通知</h5></span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">

                                <div class="card col-md-12 pl-0 pr-0 m-0 mb-2">
                                    <div class="card-header">
                                        <div class="row">
                                            <span class="col-md-12 text-left">本人確認の申請</span>
                                        </div>
                                    </div>
                                    <div class="card-body pt-0">
                                        <div class="">
                                            <div class="pt-3" v-if="allIdentificationList.length > 0">
                											        <div v-for="(identification, index) in allIdentificationList" style="cursor: pointer;">
                                                <span @click="jumpSeller(identification['sellers_id'])">・{{ convert_jst_for_message(identification['updated_at']) }}  </span>
                                                <span @click="jumpSeller(identification['sellers_id'])" v-if="identification['user_type'] == 2">
                                                  <strong v-if="identification['legal_person']==1">{{ cinit(identification['corp_name'], '-') }}</strong>
                                                  <strong v-else-if="identification['legal_person']==0">{{ cinit(identification['store_name'], '-') }}</strong>
                                                </span>
                                                <span @click="jumpSeller(identification['sellers_id'])">{{ getUserName(identification) }}</span>
                                              </div>
                                            </div>
                                            <div class="pt-3" v-else>
                                              確認データが存在しません
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card col-md-12 pl-0 pr-0 m-0 mb-2">
                                    <div class="card-header">
                                        <div class="row">
                                            <span class="col-md-12 text-left">販売者ページの確認</span>
                                        </div>
                                    </div>
                                    <div class="card-body pt-0">
                                        <div class="">
                                            <div class="pt-3" v-if="allSellerConfirmList.length > 0">
                											        <div v-for="(seller_confirm, index) in allSellerConfirmList" style="cursor: pointer;">
                                                <span @click="jumpSellerPage(seller_confirm['sellers_id'])">・{{ convert_jst_for_message(seller_confirm['updated_at']) }}  </span>
                                                <span @click="jumpSellerPage(seller_confirm['sellers_id'])" v-if="seller_confirm['user_type'] == 2">
                                                  <strong v-if="seller_confirm['legal_person']==1">{{ cinit(seller_confirm['corp_name'], '-') }}</strong>
                                                  <strong v-else-if="seller_confirm['legal_person']==0">{{ cinit(seller_confirm['store_name'], '-') }}</strong>
                                                </span>
                                                <span @click="jumpSellerPage(seller_confirm['sellers_id'])">{{ getUserName(seller_confirm) }}</span>
                                              </div>
                                            </div>
                                            <div class="pt-3" v-else>
                                              確認データが存在しません
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card col-md-12 pl-0 pr-0 m-0">
                                    <div class="card-header">
                                        <div class="row">
                                            <span class="col-md-12 text-left">商品ページの確認</span>
                                        </div>
                                    </div>
                                    <div class="card-body pt-0">
                                        <div class="">
                                            <div class="pt-3" v-if="allProductConfirmList.length > 0">
                											        <div v-for="(product_confirm, index) in allProductConfirmList" style="cursor: pointer;">
                                                <span @click="jumpProductPage(product_confirm['products_id'])">・{{ convert_jst_for_message(product_confirm['updated_at']) }}  </span>
                                                <span @click="jumpProductPage(product_confirm['products_id'])">{{ cinit(product_confirm['title'], '-') }}  </span>
                                                <span @click="jumpProductPage(product_confirm['products_id'])" v-if="product_confirm['user_type'] == 2">
                                                  <strong v-if="product_confirm['legal_person']==1">{{ cinit(product_confirm['corp_name'], '-') }}</strong>
                                                  <strong v-else-if="product_confirm['legal_person']==0">{{ cinit(product_confirm['store_name'], '-') }}</strong>
                                                </span>
                                                <span @click="jumpProductPage(product_confirm['products_id'])">{{ getUserName(product_confirm) }}</span>
                                              </div>
                                            </div>
                                            <div class="pt-3" v-else>
                                              確認データが存在しません
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="card col-md-12 pl-0 pr-0 m-0 mb-2">
                        <div class="card-header" style="background: linear-gradient(to bottom, #f9f9f9 0%, #ececec 100%);">
                            <div class="row">
                                <span class="col-md-12 text-left"><h5 class="mb-0">ユーザからの通知</h5></span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">

                                <div class="card col-md-12 pl-0 pr-0 m-0">
                                    <div class="card-header">
                                        <div class="row">
                                            <span class="col-md-12 text-left">お問い合わせの確認</span>
                                        </div>
                                    </div>
                                    <div class="card-body pt-0">
                                        <div class="">
                                            <div class="pt-3" v-if="allContactConfirmList.length > 0">
                											        <div v-for="(contact_confirm, index) in allContactConfirmList" style="cursor: pointer;">
                                                <template v-if="String(contact_confirm['message']['last_send_users_id']) != String(contact_confirm['i']['id'])">
                                                  <span @click="jumpMessageDetail(contact_confirm['message']['id'], contact_confirm['message']['status'], contact_confirm['you']['id'])">・{{ convert_jst_for_message(contact_confirm['message']['updated_at']) }}  </span>
                                                  <span @click="jumpMessageDetail(contact_confirm['message']['id'], contact_confirm['message']['status'], contact_confirm['you']['id'])" v-if="contact_confirm['you']['user_type'] == 2">
                                                    <strong v-if="contact_confirm['you']['legal_person']==1">{{ cinit(contact_confirm['you']['corp_name'], '-') }}</strong>
                                                    <strong v-else-if="contact_confirm['you']['legal_person']==0">{{ cinit(contact_confirm['you']['store_name'], '-') }}</strong>
                                                  </span>
                                                  <span @click="jumpMessageDetail(contact_confirm['message']['id'], contact_confirm['message']['status'], contact_confirm['you']['id'])">{{ getUserName(contact_confirm['you']) }}</span>
                                                </template>
                                              </div>
                                            </div>
                                            <div class="" v-if="contact_confirm_zero">
                                              確認データが存在しません
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

      </div>

  </div>
</template>

<script>
export default {
  props: { 
    user: Object
  },
  data() {
    return {
      // 販売者お知らせ
      identification_list: [],
      seller_confirm_list: [],
      product_confirm_list: [],
      // ユーザお知らせ
      display: 9, // '':すべて 2:購入申し込み者 1:試弾申し込み者 0:問い合わせ 9:運営
      contact_confirm_list: [],
      contact_confirm_zero: true,
    }
  },
	methods: {
    jumpSeller: function (id) {
      window.open('/mypage?page=3&users_id='+id, '_blank')
      return false;
      // this.$router.push({path: '/mypage', query: {page: 3, users_id: id}});
      // return false;
    },
    jumpSellerPage: function (id) {
      window.open('/seller/'+String(id), '_blank')
      return false;
      // this.$router.push({path: '/seller/'+String(id)});
      // return false;
    },
    jumpProductPage: function (id) {
      window.open('/product/'+String(id), '_blank')
      return false;
      // this.$router.push({path: '/product/'+String(id)});
      // return false;
    },
	  jumpMessageDetail: function(id, status, users_id){
      window.open('/message/'+String(users_id)+'/'+String(status)+'/'+String(id), '_blank')
      return false;
        // this.$router.push({path: '/message/'+String(users_id)+'/'+String(status)+'/'+String(id)});
	  },
	  async get_dashboard() {
		  this.$store.dispatch('user/get_dashboard', {}).then(res => {
		    let ret = res.data;
		    console.log(ret);
		    this.identification_list = ret['identification_list'];
        this.seller_confirm_list = ret['seller_confirm_list'];
        this.product_confirm_list = ret['product_confirm_list'];
        // this.contact_confirm_list = ret['contact_confirm_list'];
		  }, error => {
		    console.log('error発生');
		    console.log(error);
		    this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
		    });
  	  });
	  },
	  async get_message() {
		  this.$store.dispatch('message/get_message', {
        status: this.display,
      }).then(res => {
		    console.log(res);
		    let ret = res.data.messages;
		    this.contact_confirm_list = ret['messages'];
		    console.log(this.contact_confirm_list);
        if (this.contact_confirm_list.length > 0) {
          for(var i = 0 ; i < this.contact_confirm_list.length ; i++) {
            if ( String(this.contact_confirm_list[i]['message']['last_send_users_id']) != String(this.contact_confirm_list[i]['i']['id']) ) {
              this.contact_confirm_zero = false;
            }
          }
        }
        window.scrollTo({
          top: 0,
        });
		  }, error => {
		    console.log('error発生');
		    console.log(error);
		    this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
		    });
  	  });
	  },
  },
	computed: {
		allIdentificationList: function() {
			return this.identification_list;
		},
		allSellerConfirmList: function() {
			return this.seller_confirm_list;
		},
		allProductConfirmList: function() {
			return this.product_confirm_list;
		},
		allContactConfirmList: function() {
			return this.contact_confirm_list;
		},
  },
  created() {
    this.get_dashboard();
		this.get_message();
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mypage/admin/main.vue